import React from 'react';

function formatBirthday(value) {
  // Remove all non-digits
  const digits = value.replace(/\D/g, "");
  let formatted = "";
  if (digits.length > 0) formatted += digits.slice(0, 2);
  if (digits.length > 2) formatted += "/" + digits.slice(2, 4);
  if (digits.length > 4) formatted += "/" + digits.slice(4, 8);
  return formatted;
}

function LoginPage({ input, setInput, handleSubmit, error }) {
  // Handler to format as MM/DD/YYYY
  const handleInputChange = (e) => {
    const raw = e.target.value;
    setInput(formatBirthday(raw));
  };
  return (
    <div className="auth-page" style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #ffe0e9 0%, #fff8f0 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
    }}>
      <div style={{
        background: 'white',
        borderRadius: '24px',
        boxShadow: '0 8px 32px rgba(255,182,185,0.18), 0 1.5px 8px #ffb6b9',
        padding: '2.5em 2.5em 2em 2.5em',
        maxWidth: 480,
        minWidth: 320,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        animation: 'fadeIn 1.2s cubic-bezier(.4,0,.2,1)'
      }}>
        <div style={{
          position: 'absolute',
          top: -38,
          left: '50%',
          transform: 'translateX(-50%)',
          background: '#ffb6b9',
          borderRadius: '50%',
          width: 64,
          height: 64,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 12px #ffb6b9a0',
          fontSize: 36,
          border: '4px solid #fff8f0',
          zIndex: 2
        }}>💌</div>
        <h2 style={{
          marginTop: 40,
          marginBottom: 18,
          fontFamily: "'Caveat', cursive",
          fontWeight: 700,
          color: '#c94f7c',
          letterSpacing: '0.02em',
          fontSize: '2em',
          textAlign: 'center',
        }}>
          Open Your Love Letter
        </h2>
        <form onSubmit={handleSubmit} style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <label htmlFor="pw" style={{
            color: '#c94f7c',
            fontWeight: 500,
            marginBottom: 8,
            fontSize: '1em',
            letterSpacing: '0.01em',
            textAlign: 'center',
            width: '100%'
          }}>
            Enter our anniversary<br /><span style={{fontSize: '0.9em', color: '#b07a8c'}}>(MM/DD/YYYY)</span>
          </label>
          <input
            id="pw"
            type="text"
            inputMode="numeric"
            autoComplete="off"
            placeholder="MM/DD/YYYY"
            value={input}
            onChange={handleInputChange}
            maxLength={10}
            style={{
              padding: '0.7em 1em',
              fontSize: '1.1em',
              borderRadius: '8px',
              border: '1.5px solid #ffb6b9',
              marginBottom: '1.2em',
              marginTop: 4,
              outline: 'none',
              width: '100%',
              background: '#fff8f0',
              color: '#c94f7c',
              boxShadow: '0 1px 4px #ffb6b933',
              transition: 'border 0.2s',
              letterSpacing: '0.1em',
            }}
            onFocus={e => e.target.style.border = '2px solid #c94f7c'}
            onBlur={e => e.target.style.border = '1.5px solid #ffb6b9'}
          />
          <button type="submit" style={{
            padding: '0.7em 2.5em',
            fontSize: '1.1em',
            borderRadius: '8px',
            background: 'linear-gradient(90deg, #ffb6b9 60%, #ffe0e9 100%)',
            border: 'none',
            color: '#fff',
            fontWeight: 700,
            cursor: 'pointer',
            boxShadow: '0 2px 8px #ffb6b955',
            letterSpacing: '0.03em',
            marginBottom: 8,
            marginTop: 2,
            transition: 'background 0.2s',
          }}
          >Open</button>
        </form>
        {error && <div style={{ color: '#c94f7c', marginTop: '0.5em', fontWeight: 500, fontSize: '1em', textAlign: 'center' }}>{error}</div>}
        <div style={{
          marginTop: 24,
          color: '#b07a8c',
          fontSize: '0.95em',
          textAlign: 'center',
          opacity: 0.7
        }}>
          <span style={{fontSize: '1.2em'}}>✉️</span> This letter is sealed just for you.
        </div>
      </div>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(24px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}

export default LoginPage;
